'use client';

import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import Link from 'next/link';
import {
  Box,
  Container,
  Typography,
  Link as MuiLink,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

const COOKIES = [
  { name: 'next-auth.session-token', purpose: 'Session authentication', provider: 'FloAI', duration: 'Session', type: 'Strictly necessary' },
  { name: '__Secure-next-auth.csrf-token', purpose: 'CSRF protection', provider: 'FloAI', duration: 'Session', type: 'Strictly necessary' },
  { name: 'cookie-consent', purpose: 'Store your cookie preferences', provider: 'FloAI', duration: '1 year', type: 'Preferences' },
  { name: '_ga, _gid', purpose: 'Analytics (if enabled)', provider: 'Google Analytics', duration: '2 years / 24 hours', type: 'Analytics' },
];

const CookiesPage = () => {
  return (
    <PublicPageLayout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h3" fontWeight={700} mb={2} color="text.primary" component="h1">
          Cookie Policy
        </Typography>
        <Typography variant="subtitle2" color="text.secondary" mb={4}>
          Last updated: March 2026
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography variant="body1" color="text.primary">
            We use cookies and similar technologies to provide, secure, and improve our service. This policy explains what we use and how you can control it.
          </Typography>

          <Typography variant="h5" fontWeight={700} color="text.primary">
            What we use
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Strictly necessary:</strong> Required for sign-in, security, and core site function. You cannot turn these off.
            <br />
            <strong>Preferences:</strong> Remember your settings (e.g. theme, consent choices).
            <br />
            <strong>Analytics (if enabled):</strong> Help us understand how the site is used so we can improve it.
          </Typography>

          <Typography variant="h6" fontWeight={700} color="text.primary">
            Cookie list (overview)
          </Typography>
          <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
            <Table size="small" aria-label="Cookies overview">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Cookie name</strong></TableCell>
                  <TableCell><strong>Purpose</strong></TableCell>
                  <TableCell><strong>Provider</strong></TableCell>
                  <TableCell><strong>Duration</strong></TableCell>
                  <TableCell><strong>Type</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {COOKIES.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.purpose}</TableCell>
                    <TableCell>{row.provider}</TableCell>
                    <TableCell>{row.duration}</TableCell>
                    <TableCell>{row.type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Typography variant="h6" fontWeight={700} color="text.primary">
            How to control cookies
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            You can change your browser settings to block or delete cookies. Blocking strictly necessary cookies may prevent you from signing in or using parts of the site. For third-party analytics, use the provider opt-out tools (e.g. Google Analytics opt-out) where available.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            For more on how we handle data, see our{' '}
            <MuiLink component={Link} href="/privacy" color="primary">
              Privacy Policy
            </MuiLink>.
          </Typography>
        </Box>
      </Container>
    </PublicPageLayout>
  );
};

export default CookiesPage;
